var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SearchContentHeader"},[_vm._t("actions"),_c('div',{staticClass:"SearchContentHeader__delimiter"}),_vm._t("selectors")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }